import { Controller } from "stimulus"
import { Ajax } from "ajax"

export default class extends Controller {

  static targets = [
    "content",
    "text",
    "footer",
    "submitButton",
    "toDisable",
    "form",
    "showForm",
    "wrapper",
    "userMessages",
    "messageAfterSend"
  ]

  static values = {
    formIsDirty: Boolean
  }

  connect() {
    let controller = this;

    window.addEventListener("beforeunload", function (event) {
      if (controller.formIsDirtyValue) {
        event.preventDefault()
        return event.returnValue = ''
      }
    });    

    this.checkDirtyness()
  }

  showForm() {
    this.formTarget.classList.remove('hidden')
    this.showFormTarget.classList.add('hidden')
  }

  checkDirtyness() {
    let isClean = this.textTarget.value == ''

    if (isClean) {
      this.submitButtonTarget.classList.add('disabled')
    } else {
      this.submitButtonTarget.classList.remove('disabled')
    }

    this.submitButtonTarget.disabled = isClean
    this.formIsDirtyValue = !isClean
  }

  reset() {
    this.textTarget.value = ""
    this.contentTarget.innerHTML = ""
    this.footerTarget.classList.remove('disabled')
    this.toDisableTargets.forEach(el => el.disabled = false)
    this.checkDirtyness()
  }

  submitForm(e) {
    this.formIsDirtyValue = false
    
    // this.toDisableTargets.forEach((el) => {
    //   el.disabled = true
    //   el.classList.add("disabled")
    // })

    this.messageAfterSendTargets.forEach((el) => {
      el.classList.remove("hidden")
    })

    this.formTarget.classList.add("hidden")
    return true
  }

}